export const allStringSet = (...values: string[]) => {
    for (let v in values)
        if (values[v] === "") return false;
    return true;
};

export const round = (result: number, length: number) => {
    const moveLength = Math.pow(10, length);
    return (Math.round(result * moveLength) / moveLength);
};